import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class CloseRequestPayload extends RequestPayload {
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/requests/close-request-payload.ts